import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pcomment(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Comments Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python Comment tutorial for beginners.in Comments you should add notes within your programs that describe your overall approach to the problem you’re solving" />
<meta name="keywords" content="codeexampler,python comment,comment in python,python comment multiple lines,python comment block,python comment line,python comment out,python comment syntax" />
<link rel="canonical" href="https://www.codeexampler.com/python-comments" />
</Helmet>

<div className='lg:pl-56'>

 
    <h1 className="m-4 mh1">Python Comments</h1>
    <div className="first">
        <a href="/python-input">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-operators">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    <h2 className="mt-4 mh2">Comment in Python:</h2>
    <p className="mt-4 para"> Comments used only for reading. Comments start with the use of ( # ) Character. So this Hash Symbol (#) indicates as a Comment.
    
</p>
<h2 className="mt-4 mh2">There are Three Forms of python comment:</h2>
<h3 className="mt-4 mh3">1, Single-line comment in python<br/>
2, Inline comments<br/>
3, Multi-Line comments
</h3>

<h2 className="mt-4 mh2">1, Single line comment in python:</h2>
<p className="mt-3 para">Single line comment started with the hash character (#) and Terminated by the end of the line.</p>



<h2 className='headings'>Single line comment Example in Python:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10"># this can be one line comment in python</span>
            {"\n"}
                <span className="qwerty-10"># print two names.</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>


<h2 className="mt-4 mh2">2, Python comment inline: </h2>
<p className="mt-4 para">This type of comment puts at the end of the line. 
</p>



<h2 className='headings'>Inline comment Example in Python:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-3">print</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-8">Ram Chaudhary</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-10"> #This line print one name </span>
            {"\n"}
                <span className="qwerty-4">a</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-2">10</span>
                <span className="qwerty-10"> # Assign 10 to a </span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>    


<h2 className="mt-4 mh2">3, Python comment on multiple lines:</h2>
<p className="mt-4 para">If you want to use more than one line for comments.</p>


<h2 className='headings'>Multiple line comment Example in Python:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10">#</span>
                <span className="qwerty-3"> ******************</span>
            {"\n"}
                <span className="qwerty-10">#</span>
                <span className="qwerty-4"> This is a Multi-line comments </span>
            {"\n"}
                <span className="qwerty-10">#</span>
                <span className="qwerty-3"> ******************</span>
                
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>       

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-input"> <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-operators"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Pcomment;